// extracted by mini-css-extract-plugin
export default {"sidebar":"TabsMenu_sidebar__zBHB-","ul":"TabsMenu_ul__hBJl0","li":"TabsMenu_li__XVyQG","liActive":"TabsMenu_liActive__0NyJc"};